import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import { AutopilotPlan } from 'components/Settings/Workspace/VirtualMarketerUpgradeCta/types'

export const LOW_CREDIT_THRESHOLD_RATIO = 0.1

export const findPlanCreditLimit = (plans: AutopilotPlan[], planKey: PaymentPlanKey): number => {
  const plan = plans.find((p) => p.key === planKey)
  const limit = plan?.prices[0]?.metadata?.credit_limit
  return limit != null ? Number(limit) : 0
}

/**
 * Plans that include Campaigns. Growth and Enterprise both have them; Starter and Pioneer are
 * upsold to Growth. Enterprise is the highest tier, so checking for Growth alone would tell those
 * workspaces to upgrade to a plan below the one they already pay for.
 */
export const CAMPAIGN_PLAN_KEYS: PaymentPlanKey[] = [
  PaymentPlanKey.BlazeAutopilotGrowth,
  PaymentPlanKey.BlazeAutopilotEnterprise,
]

export const canCreateCampaigns = (planKey?: PaymentPlanKey | null): boolean =>
  !!planKey && CAMPAIGN_PLAN_KEYS.includes(planKey)
